import axios from 'axios';

// Request interceptor to modify headers before sending a request
export const requestInterceptor = (config) => {
  const token = localStorage.getItem('token'); // Retrieve your token
  // Check if token is missing or invalid
  if (!token || token === 'undefined' || token === 'null') {
    console.warn('No valid token found — request cancelled.');
    // Cancel the request before it is sent
    throw new Error('Request cancelled: No authentication token found');
  }

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
};

// Response interceptor to handle responses globally
export const responseInterceptor = (response) => {
  return response;
};

export const errorInterceptor = (error) => {
  // Handle error globally (e.g., Unauthorized error handling)
  if (error.response && error.response.status === 401) {
     localStorage.clear();
     window.location.href = '/';
    console.error('Unauthorized, please log in again.');
    // You could trigger a logout or redirect here
  }
  return Promise.reject(error);
};